import { memo } from 'react';
import { cx } from '@trinity/chat-components/utils';
import styles from './style/Divider.module.css';

type Props = {
  className?: string;
};

export const PopperMenuDivider = memo((props: Props) => {

  const className = cx(styles.divider, props.className);

  return (
    <div className={className} />
  );
});